import { twMerge } from 'tailwind-merge';

function H1({
  children,
  dataTest = 'header',
  className,
}: {
  children?: React.ReactNode;
  dataTest?: string;
  className?: string;
}) {
  return (
    <h1
      className={twMerge(
        'mb-6 font-semibold text-3xl text-center lg:text-4xl lg:text-start',
        className,
      )}
      data-test={dataTest}
    >
      {children}
    </h1>
  );
}

export default H1;
